var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPromo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M12 6.5V4m0 2.5H9.5C7.843 6.5 7 5.5 7 4s1-2.5 2.5-2.5S12 2.5 12 4m0 2.5h2.5C16 6.5 17 5.5 17 4s-1-2.5-2.5-2.5S12 2.343 12 4m-7.5 8v9.5h15V12M12 7v14"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M3.5 11.5v-5h17v5h-17z"
  }));
}
export default SvgIconPromo;